import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface BlogAuthorProps {
  name: string;
  avatarUrl?: string;
  publishedAt: string;
  updatedAt?: string;
  readingTime: number;
}

const formatDate = (iso: string) => new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });

export function BlogAuthor({ name, avatarUrl, publishedAt, updatedAt, readingTime }: BlogAuthorProps) {
  const showUpdated = !!updatedAt && updatedAt.slice(0, 10) !== publishedAt.slice(0, 10);
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2);

  return (
    <div className="flex items-center gap-3">
      <Avatar className="h-10 w-10">
        <AvatarImage src={avatarUrl} alt={name} />
        <AvatarFallback className="bg-primary/10 text-primary text-sm font-semibold">
          {initials}
        </AvatarFallback>
      </Avatar>
      <div>
        <p className="text-sm font-semibold text-foreground">{name}</p>
        <p className="text-xs text-muted-foreground">
          {showUpdated ? (
            <>Updated <time dateTime={updatedAt}>{formatDate(updatedAt!)}</time></>
          ) : (
            <time dateTime={publishedAt}>{formatDate(publishedAt)}</time>
          )}{' '}
          · {readingTime} min read
        </p>
      </div>
    </div>
  );
}
